var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import { useState, useEffect, useCallback, useRef } from 'react';
import { submitUndo } from '../services/chatApi';
const DEFAULT_UNDO_WINDOW_MS = 10000;
export function useUndoTimer({ conversationId, undoWindowMs = DEFAULT_UNDO_WINDOW_MS, onUndoExpired }) {
    const [activeActionId, setActiveActionId] = useState(null);
    const [remainingMs, setRemainingMs] = useState(0);
    const [isUndoing, setIsUndoing] = useState(false);
    const intervalRef = useRef(null);
    const startTimeRef = useRef(0);
    const clearTimer = useCallback(() => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    const startUndo = useCallback((actionId) => {
        clearTimer();
        setActiveActionId(actionId);
        setRemainingMs(undoWindowMs);
        startTimeRef.current = Date.now();
        intervalRef.current = setInterval(() => {
            const elapsed = Date.now() - startTimeRef.current;
            const remaining = Math.max(0, undoWindowMs - elapsed);
            setRemainingMs(remaining);
            if (remaining <= 0) {
                clearTimer();
                setActiveActionId(null);
                onUndoExpired === null || onUndoExpired === void 0 ? void 0 : onUndoExpired();
            }
        }, 100);
    }, [undoWindowMs, clearTimer, onUndoExpired]);
    const executeUndo = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        if (!activeActionId || !conversationId)
            return;
        clearTimer();
        setIsUndoing(true);
        try {
            yield submitUndo({ conversation_id: conversationId, action_id: activeActionId });
        }
        finally {
            setIsUndoing(false);
            setActiveActionId(null);
            setRemainingMs(0);
        }
    }), [activeActionId, conversationId, clearTimer]);
    const cancelUndo = useCallback(() => {
        clearTimer();
        setActiveActionId(null);
        setRemainingMs(0);
    }, [clearTimer]);
    useEffect(() => clearTimer, [clearTimer]);
    return { activeActionId, remainingMs, startUndo, executeUndo, cancelUndo, isUndoing };
}
